/**
 *
 * NativeNotification
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { slideDown } from 'styles/animation';
import ReactHtmlParser from 'react-html-parser';

const MessageWrapper = styled.div`
  background-color: ${p => p.variant === 'success' ? p.theme.palette.success : p.theme.palette.error };
  padding: 5px 1rem;
  width: 70%;
  margin: 0 auto;
  color: white;
  font-size: 12px;
  text-align: center;
  font-weight: 700;
  font-size: 12px;
  border-radius: 5px;
  opacity: 0;
  transform: translateY(-10px);
  animation: ${slideDown} 0.4s ease-in-out 0.15s forwards;
`;

export const NativeNotification = props => {
  const { variant, message } = props;
  return (
    <MessageWrapper id="insent-native-notification-message-wrapper" variant={variant}>
      {ReactHtmlParser(message)}
    </MessageWrapper>
  );
}

NativeNotification.propTypes = {
  variant: PropTypes.string,
  message: PropTypes.string,
};

NativeNotification.defaultProps = {
  variant: 'success',
  message: ''
}

export default NativeNotification;
